<template>
    <div class="tsa-loginForm">
        <div class="form-content">
            <h2 v-if="validateInfo.activityStatus===0">立即注册得价值300元优惠券大礼包</h2>
            <h2 v-else>立即登录/注册，固定您的维权证据！</h2>
            <p class="tip">30秒注册，维权证据早固定早安心！</p>
            <div class="form-area">
                <div class="item">
                    <p class="name">手机号</p>
                    <div class="value">
                        <input type="text" v-model="ruleForm.loginName" placeholder="请输入手机号">
                    </div>
                </div>
                <div class="item">
                    <p class="name">验证码</p>
                    <div class="value">
                        <input type="text" v-model="ruleForm.password" placeholder="请输入验证码">
                        <div class="verifyCode">
                            <TsaVerifyCode ref="TsaVerifyCode" :phone="ruleForm.loginName" type="phone" @on-start="getCodeSuccess"></TsaVerifyCode>
                        </div>
                    </div>
                </div>
                <div class="checked">
                    <el-checkbox v-model="checked"></el-checkbox>
                    <p><label @click="checked=!checked">我已阅读并同意</label><span class="blue" @click="gotoAgreement(0)">《用户注册与使用协议》</span><span class="">和</span><span class="blue" @click="gotoAgreement(1)">《隐私保护协议》</span></p>
                </div>
                <div class="btn" @click="submit">
                    <p>登录/注册</p>
                </div>
            </div>
        </div>
        <!-- 注册协议 -->
        <TsaAgreementDialog v-model="regDialog" title="协议更新" @on-cancel="cancelDialog" @on-agree="agree('signup')">
            <RegDocUpdateTips @openRegistrationDialog='registrationDialog=true,regDialog=false' />
        </TsaAgreementDialog>
         <!-- 隐私协议 -->
        <TsaAgreementDialog v-model="privacyDialog" title="隐私保护协议" @on-cancel="nologin" @on-agree="agree('PRIVACY')">
            <iframe class="agreementDoc" :src="privacyAgreement" frameborder="0"></iframe>
        </TsaAgreementDialog>
        <!-- 用户注册与使用协议 -->
        <TsaAgreementDialog v-model="registrationDialog" title="用户注册与使用协议" type='alert' @on-cancel="regDialog=true,registrationDialog=false">
            <iframe class="agreementDoc" :src="regAgreement" frameborder="0"></iframe>
        </TsaAgreementDialog>
    </div>
</template>

<script>
import TsaVerifyCode from '../verifyCode'
import { sendMsg, login, signProtocol } from '@/api/promote'
import {loginout } from '@/api/userCenter'
import {me} from "@/api/service";
import NoTrace from '@/utils/noTrace';
import { mobilePhoneReg, emailReg } from '@/config/regular.js'
import { mapState } from 'vuex'
import TsaAgreementDialog from './components/agreementDialog/index.vue'
import RegDocUpdateTips from './components/RegDocUpdateTips.vue';
import { GetRequest } from '@/common/utils'
import qs from 'qs'
export default {
    components: {
        TsaVerifyCode,
        TsaAgreementDialog,
        RegDocUpdateTips
    },
    props:{
        validateInfo:{
            type: [String,Object], 
            default: ''
        },
    },
    data () {
        return {
            checked: false,
            regDialog:false,
            registrationDialog:false,
            privacyDialog:false,
            regAgreement:process.env.VUE_APP_USERCENTERUI+'/agreement/registration',
            privacyAgreement:process.env.VUE_APP_USERCENTERUI+'/agreement/privacy',
            ruleForm: {
                loginName: '',
                password: '',
            },
            loginRes:'',
        }
    },
    computed: {
        ...mapState({
            visualDeviceType: (state) => state.App.visualDeviceType,
        }),
    },
    mounted () {
        
    },
    beforeDestroy() {
        NoTrace.reset()
    },
    methods: {
        async gologin(res){
            if(res){
                this.loginSuccessFinalRes(res)
                return
            }
            try {
                let result = await me();
                //this.$store.commit('UserInfo/setUserInfo', result || {})
                this.loginSuccessFinalRes(result)
            } catch (error) {
                console.log(error)
            }
            
        },
        cancelDialog(){
            this.regDialog=false;
            if(this.protocolUpdateStatus==1){
                this.privacyDialog=true;
            }else{
                this.gologin();
            }
        },
        agree(protocolType){
            let that=this;
            that.regDialog=false;
            that.privacyDialog=false;
            signProtocol({ protocolType:protocolType},this.access_token).then((res) => {
                if(res.protocolUpdateStatus==1){
                    that.privacyDialog=true;
                    return false;
                }
                that.gologin(this.loginRes);
            })
        },
        nologin(){
            let that=this;
            loginout().then((res) => {
                that.privacyDialog=false;
            }).catch((err) => {
                console.log(err);
            });
        },
        executeFun (params) {
            let that=this;
            return new Promise(async (resolve, reject) => {
                try {
                    let res = await sendMsg(params);
                    resolve(res)
                    that.$TsaToastV2.show({
                        message: '验证码发送成功',
                        type: 'success',
                    })
                }catch (error) {
                    reject(error)
                    that.$refs.TsaVerifyCode.reset();
                    // 阿里无痕验证失败
                    if (error.aliFali) {
                        that.$TsaToastV2.show({
                            message: '短信验证码发送失败',
                            type: 'error',
                        })
                    } else {                       
                        that.$TsaToastV2.show({
                            message: error.data.message || '短信验证码发送失败',
                            type: 'error',
                        })
                    }
                }
            })
        },
        getCodeSuccess ({ signupType } = {}) {
            NoTrace.start((nvc) => {
                this.nvc = nvc
                this.$refs.TsaVerifyCode.getCode();
            }, this.executeFun, {
                signupType,
                loginName: this.ruleForm.loginName,
                afsVersion: 2,
            })
        },
        submit () {
            let signupType = ''
            if (mobilePhoneReg.test(this.ruleForm.loginName)) {
                signupType = 'PHONE'
                this.submitFun(signupType)
            } else {
                this.$TsaToastV2.show({
                    type: 'warn',
                    message: '请输入正确的手机号'
                })
            }
            
        },
        submitFun (signupType) {
            if (!this.ruleForm.password) {
                this.$TsaToastV2.show({
                    type: 'warn',
                    message: '请输入验证码'
                })
                return
            }
            if (!this.nvc) {
                return this.$TsaToastV2.show({
                    type: 'warn',
                    message: '请获取验证码'
                })
            }
            if (!this.checked) {
                this.$TsaConfirmV2.show({
                    message: '您是否阅读并同意<span style="color: #165DFF;cursor:pointer" id="registration">《用户注册与使用协议》</span>和<span style="color: #165DFF;cursor:pointer" id="privacy">《隐私保护协议》</span>？',
                    cancelButtonText: '拒绝',
                    confirmButtonText: '同意',
                    onOpen: () => {
                        this.domClcik()
                    },
                    onConfirm: () => {
                        this.$TsaConfirmV2.hide()
                        this.checked = true
                        this.submitFun()
                    }
                })
                return
            }
            this.$TsaLoadingV2.show()
            let loginName = this.ruleForm.loginName.trim()
            let password = this.ruleForm.password.trim()
            let promoteCode = GetRequest().promoteCode
            login({
                phone:loginName,
                code:password,
                promoteCode,
            }).then((result) => {
                this.$TsaLoadingV2.hide()
                this.loginRes=result
                this.loginSuccessRes(result)
            }).catch((error) => {
                this.$TsaLoadingV2.hide()
                this.loginFailRes(error)
            });
        },
        // 协议跳转 登录  注册页面需要
        loginSuccessRes (result) {
            let { signupProtocolUpdateStatus, protocolUpdateStatus, accessToken } = result
            this.access_token = accessToken
            // 注册协议更新 1.不需要弹出更新协议框 2. 需要弹出.    // 隐私协议更新需要授权
            // 注册协议更新 1.不需要弹出更新协议框 2. 需要弹出
            if (signupProtocolUpdateStatus === 2) {
                this.regDialog = true
                return
            }
            // 隐私协议更新需要授权
            if (protocolUpdateStatus === 1) {
                this.privacyDialog = true
                return
            }
            // 登录成功
            zhuge.track('裂变-被邀请页-登录/注册',{
                '推广分类':'版权保护',
                '渠道':'H5',
                '注册状态':[0,1].includes(result.status)?'新注册':'已注册'
            },()=>{
                this.loginSuccessFinalRes(result)
            })
        },
        loginSuccessFinalRes (result) {
            let obj = {
                code: GetRequest().promoteCode,
                redirectUrl: encodeURIComponent(window.location.href),
                sourcePlatform: 'ipr',
                status:result.status
            }
            window.location.href = process.env.VUE_APP_BD +'/dist-m/promoteSuccess' + '?' + qs.stringify(obj)
        },
        loginFailRes (error) {
            if (error) {
                let { status, data }  = error
                if (status === 403) {
                    if (data) {
                        let { code, message } = data
                        if(code===20031){
                            this.$TsaAlert.show({
                                title: '温馨提示',
                                message: `<span style="font-size:18px">该活动暂时仅支持主账号参加，请切换账号<span>`,
                                onConfirm: () => {
                                    this.$TsaAlert.hide()
                                }
                            })
                        }else{
                            this.$TsaToastV2.show({
                                type: 'error',
                                message
                            })
                        }
                    } else {
                        this.$TsaToastV2.show({
                            type: 'error',
                            message: '系统异常'
                        })
                    }
                }
            }
        },
        domClcik () {
            this.$nextTick(() => {
                document.querySelector('#registration').onclick = () => {
                    this.gotoAgreement(0)
                }
                document.querySelector('#privacy').onclick = () => {
                    this.gotoAgreement(1)
                }
            })
        },
        gotoAgreement (val) {
            let url, title
            switch (val) {
                case 0:
                    title = '用户注册与使用协议'
                    url = process.env.VUE_APP_USERCENTERUI + '/agreement/registration'
                break
                case 1:
                    title = '隐私保护协议'
                    url = process.env.VUE_APP_USERCENTERUI + '/agreement/privacy'
                break
            }
            window.open(url)
        },
    }
}
</script>

<style lang="scss" scoped>
    .agreementDoc {
        width: 100%;
        height: 100%;
    }
    @media screen and (min-width:1101px) {
        @import './css/pc.scss';
    }
    @media screen and (max-width:1100px) {
        @import './css/mobile.scss';
    }
</style>